module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAA/klEQVQ4y63SIU/DQBiH8ec2NGpfADVJUnAzU0yQERAlwS0ogsNgQaDAMjezZN8B+BTQhKAQo5lA4CBZ6cQfUZax0bXXXV93zeWXJ/cWShz5XJSKyUemxLJLAGfwL+YMLmJOYBq2MrgMWwnMwgqDeVgh0AYDqDpjxkDrFNZr8P7KmjN2fJuAoxd4vKNihW144O0uxyYR9M/yy+Qj+UjhsyRJg/PkfGik+27yLR5LVy1N71Yzy6YTfcL2HmzuQBxB42hWdr0PwcMs3PrNmh046UHltyEew83BHPZvy5kLGD7BRwhbbZh8p2Jzhbb/GfUGRF/wFqQvvhBmMaZMDOAHSP5/7umJaNwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recharge/arrow_icon.png
// module id = n0ye
// module chunks = 1